import { combineReducers } from 'redux';
import { HYDRATE } from 'next-redux-wrapper';

import results, { initialState as resultsInitialState } from '@/ducks/results/resultsReducer';
import object, { initialState as objectInitialState } from '@/ducks/object/objectReducer';
import profile, { initialState as profileInitialState } from '@/ducks/profile/profileReducer';
import order, { initialState as orderInitialState } from '@/ducks/order/orderReducer';
import booking, { initialState as bookingInitialState } from '@/ducks/booking/bookingReducer';
import price, { initialState as priceInitialState } from '@/ducks/price/priceReducer';

export const initialState = {
    results: resultsInitialState,
    objectData: objectInitialState,
    profileData: profileInitialState,
    orderData: orderInitialState,
    bookingData: bookingInitialState,
    priceData: priceInitialState,
};

const combinedReducer = combineReducers({
    // TODO config is not needed??
    config: (state = {}) => state,
    bookingData: booking,
    objectData: object,
    profileData: profile,
    orderData: order,
    priceData: price,
    results,
    loginId: (state = {}) => state,
    deviceType: (state = {}) => state,
});

export const reducer = (state, action) => {
    switch (action.type) {
        case HYDRATE:
            // This action type is triggered by next-redux-wrapper when redux actions is dispatched in SSR pages,
            // i.e. in getServerSideProps. For now this only applies to the object and booking page, so map data
            // from these specifically so as not to overwrite existing client state like the result list.
            return {
                ...state,
                profileData: { ...action.payload.profileData },
                objectData: { ...action.payload.objectData },
                orderData: { ...action.payload.orderData },
                bookingData: { ...action.payload.bookingData },
                priceData: { ...action.payload.priceData },
            };
        default:
            return combinedReducer(state, action);
    }
};
